import React from "react";
import { RouterProvider } from "react-router-dom";
import router from "./AppRouter"; // Import your routes
import FormSubmissionPreloader from "./components/FormSubmissionPreloader";

function App() {
  return (
    <>
      <RouterProvider router={router} />
      <FormSubmissionPreloader />
    </>
  );
}

export default App;
